import { apiMipe } from '@/core/api/';

const messageBaseURL = 'api/message';
const calendarBaseURL = 'api/calendarEvent';

export const getMessages = () =>
  apiMipe.get(`${messageBaseURL}/mesaggefordashboard`);

export const fetchResult = (filter) =>
  apiMipe.get(`${messageBaseURL}/search`, {
    params: filter,
  });

export const fetchRol = () => apiMipe.get(`${messageBaseURL}/roles`);

export const fetchCategory = () => apiMipe.get(`${calendarBaseURL}/categories`);

export const fetchEventById = (id) => apiMipe.get(`${calendarBaseURL}/${id}`);

export const deleteEvent = (id) =>
  apiMipe.delete(`${calendarBaseURL}/delete/${id}`);

export const updateEvent = (data) =>
  apiMipe.put(`${calendarBaseURL}/edit`, data).catch((e) => {
    throw e.response.data.message;
  });

export const saveEvent = (data) =>
  apiMipe.post(`${calendarBaseURL}/save`, data).catch((e) => {
    throw e.response.data.message;
  });

export const fetchEvents = (categoryId, applicationId) =>
  apiMipe.get(
    `${calendarBaseURL}/events/0?categoryId=${categoryId}&applicationId=${applicationId}`
  );

export const fetchSchedule = (date, applicationId) =>
  apiMipe.get(`${calendarBaseURL}/dailyevents`, {
    params: {
      date: date,
      applicationId,
    },
  });
